import { ChangeDetectorRef } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from "../../services/authentication.service";
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CALENDAR_LOCALE } from '../../services/constant';
import { TemplateService } from "../../services/template.service";
import { TranslateService } from "@ngx-translate/core";
var TaxReportComponent = (function () {
    function TaxReportComponent(apiService, modalService, cdr, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.cdr = cdr;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.allBranch = true;
        this.allDocType = true;
        this.allDocumentType = [];
        this.allBranchSelected = [];
        this.currentPage = 1;
        this.loading = false;
        this.no_data = true;
        this.errorMsg = '';
        this.loadingExcel = false;
        this.loadingAllExcel = false;
        this.cofirm_loading = false;
        this.branchList = null;
        this.allBranchList = null;
        this.docTypeList = null;
        this.tableCol = [];
        this.is_TH = false;
    }
    TaxReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        // this.loadDropdown();
        //   this.searchData();
        // this.loadInput();
        this.loadTexts();
        this.pageChanged();
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
    };
    TaxReportComponent.prototype.loadTexts = function () {
        var _this = this;
        this.tableCol = [];
        // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        //   if (event.lang === 'en') {
        //     this.calendarLocale = CALENDAR_LOCALE.EN;
        //   } else {
        //     this.calendarLocale = CALENDAR_LOCALE.TH;
        //   }
        // });
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.translate.get('FILTER.DATE').subscribe(function (res) {
            _this.tableCol.push({ field: 'date', header: res }, 
            // { field: 'group', header: 'Business' },
            // {field: 'company_name', header: this.translate.instant('FILTER.COMPANY')},
            { field: 'branch', header: _this.translate.instant('TABLE.BRANCH-NAME') }, { field: 'rd_doc_type', header: _this.translate.instant('FILTER.DOCUMENT-TYPE') }, 
            // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
            { field: 'start_end_document', header: _this.translate.instant('TABLE.DOCUMENT-NUMBER-START-END') }, { field: 'total_doc', header: _this.translate.instant('TABLE.NUMBER-DOCUMENTS') }, { field: 'total_missing_doc', header: _this.translate.instant('TABLE.NUMBER-MISSING-DOCUMENTS') }, { field: 'non_vat', header: _this.translate.instant('TABLE.SALES') + ' Non-VAT' }, { field: 'basis_amount', header: _this.translate.instant('TABLE.SALES') + ' VAT' }, { field: 'vat', header: 'VAT' });
            var documentData = _this.template.getDropdown();
            documentData[0] = { label: _this.translate.instant('COMMON.ALL'), value: null };
            _this.rdDocumentType = documentData;
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
            _this.loadInput();
        });
    };
    Object.defineProperty(TaxReportComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaxReportComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    TaxReportComponent.prototype.ngAfterViewChecked = function () {
        this.cdr.detectChanges();
    };
    TaxReportComponent.prototype.loadInput = function () {
        var _this = this;
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.company = _.uniqBy(_this.company, 'label');
        }, function (error) {
            console.log('error', error);
        });
        this.homeproGroup = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.selectedCompany = null;
        this.selectedRdDocumentType = null;
    };
    TaxReportComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.selectedBranch = null;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate == _this.selectedCompany)
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
        });
    };
    TaxReportComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.searchData(params);
    };
    TaxReportComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        if (!this.no_data) {
            this.table.reset();
        }
        this.searchData();
    };
    TaxReportComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    TaxReportComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    TaxReportComponent.prototype.canUserApproveDoc = function () {
        return this.authService.isAccountant() || this.authService.isUIH();
    };
    TaxReportComponent.prototype.searchBranch = function (event) {
        var _this = this;
        if (this.branchList == null) {
            this.apiService.getBranch().subscribe(function (data) {
                _this.branchList = data;
                _this.branchSuggest = _this.filterData(event.query, 'full_name', _this.branchList);
            });
        }
        else {
            this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
    };
    TaxReportComponent.prototype.searchDocumentType = function (event) {
        var _this = this;
        if (this.docTypeList == null) {
            this.apiService.getDocumentType().subscribe(function (result) {
                _this.docTypeList = result;
                _this.typeSuggest = _this.filterData(event.query, 'type', _this.docTypeList);
            });
        }
        else {
            this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
    };
    TaxReportComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    TaxReportComponent.prototype.selectAllBranch = function () {
        this.branch = null;
    };
    TaxReportComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    TaxReportComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        this.allBranchSelected = [];
        this.allDocumentType = [];
        _.forEach(this.branch, function (data) {
            // this.allBranchSelected = [];
            _this.allBranchSelected.push(_.toNumber(data.id));
        });
        _.forEach(this.documentType, function (data) {
            // this.allDocumentType = [];
            _this.allDocumentType.push(_.toNumber(data.id));
        });
        var data = {
            not_approved_only: this.notApprove,
            header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
            corporate_group_id: this.selectedHomeproGroup,
            corporate_id: this.selectedCompany,
            document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
            //branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
            branch_id: this.selectedBranch ? [this.selectedBranch] : null,
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        if (this.currentPage === 1) {
            params = null;
        }
        this.apiService.postSaleTax(data, params).subscribe(function (result) {
            _this.loading = false;
            _this.tableData = result.results;
            _this.no_data = _.isEmpty(_this.tableData);
            _this.totalItems = result.count;
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    TaxReportComponent.prototype.confirmDocument = function (event, content, index) {
        // event.currentTarget.blur();
        document.getElementById('chkbox' + index).blur();
        event.preventDefault();
        this.modalData = this.tableData[index];
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
    };
    TaxReportComponent.prototype.confirm = function () {
        var _this = this;
        this.cofirm_loading = true;
        var params = {
            approved: this.modalData.approved,
            header_issue_date: this.modalData.header_issue_date,
            group: this.modalData.group,
            document_type: this.modalData.document_type,
            rd_document_type: this.modalData.rd_document_type,
            corporate_branch: this.modalData.corporate_branch,
        };
        this.apiService.approveSale(params).subscribe(function (result) {
            _this.cofirm_loading = false;
            _this.modal.close();
            _this.modal = null;
        }, function (error) {
            _this.cofirm_loading = false;
        });
    };
    TaxReportComponent.prototype.revertBack = function () {
        this.modalData.approved = !this.modalData.approved;
        this.modal.close();
        this.modal = null;
    };
    TaxReportComponent.prototype.clearData = function () {
        this.tableData = undefined;
        this.no_data = true;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.selectedCompany = null;
        this.selectedBranch = null;
        this.selectedRdDocumentType = null;
        this.branch = null;
        this.documentType = null;
        this.notApprove = false;
        this.allDocType = true;
        this.allBranch = true;
        this.sortBy = null;
        this.sortMode = null;
        this.searchButtonClicked();
    };
    TaxReportComponent.prototype.getExportDocs = function (data, index) {
        var _this = this;
        //this.loadingAllExcel[index] = true;
        this.tableData[index].loading_all_docs_excel = true;
        var params = {
            header_issue_dt: data.header_issue_date,
            document_type: data.document_type,
            rd_document_type: data.rd_document_type,
            corporate_branch: data.corporate_branch,
            group: data.group,
        };
        this.apiService.getAllDocs(params).subscribe(function (obj) {
            _this.tableData[index].loading_all_docs_excel = false;
            var filename = 'daily_report ' + params.header_issue_dt + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            // data.xmlLoading = false;
        }, function (error) {
            _this.tableData[index].loading_all_docs_excel = false;
            // data.xmlLoading = false;
        });
    };
    TaxReportComponent.prototype.downloadMissingDocs = function (data, index) {
        var _this = this;
        this.tableData[index].loading_missing_docs_excel = true;
        // data.xmlLoading = true;
        var params = {
            header_issue_dt: data.header_issue_date,
            document_type: data.document_type,
            rd_document_type: data.rd_document_type,
            corporate_branch: data.corporate_branch,
            max_document: data.max_document,
            min_document: data.min_document,
            group: data.group,
        };
        this.apiService.getMissingDoc(params).subscribe(function (obj) {
            _this.tableData[index].loading_missing_docs_excel = false;
            var filename = 'daily_missing ' + params.header_issue_dt + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            // data.xmlLoading = false;
        }, function (error) {
            _this.tableData[index].loading_missing_docs_excel = false;
            // data.xmlLoading = false;
        });
    };
    TaxReportComponent.prototype.clearBranch = function () {
        this.allBranchSelected = [];
    };
    TaxReportComponent.prototype.clearDocType = function () {
        this.allDocumentType = [];
    };
    TaxReportComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    TaxReportComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.branch) && this.allBranch === false) {
            errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + errorMsgList.join(', ') + this.translate.instant('COMMON.CORRECT');
            return;
        }
        // let dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
        // if ( dayDiff > 60 && this.authService.isAccountantTH() || this.authService.isAccountantINC()) {
        //   this.errorMsg = "ไม่สามารถเลือกระยะเวลาเกิน 60 วัน"
        // }
    };
    TaxReportComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
        // this.searchData();
    };
    TaxReportComponent.prototype.findData = function ($event, data) {
        console.log(data);
    };
    TaxReportComponent.prototype.isAdminlog = function () {
        return this.authService.isAdmin();
    };
    return TaxReportComponent;
}());
export { TaxReportComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.ts.pre-build-optimizer.js